import SupportList from "../../../component/users/support/SupportList"

 
   
function Support() {
  return (
    <div className="page-body"><SupportList/></div>
  )
}

export default Support